import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import {
  CallToActionPrimary,
  CallToActionSecondary
} from '../CallToAction/CallToAction';

import './CallToActionWrapper.css';

const CallToActionWrapper = ({
  isVisible,
  handleSubmitComment,
  handleCancelComment,
  isPostingEnabled
}) => {
  return (
    <div styleName={`action-wrapper ${isVisible ? 'show-actions' : ''}`}>
      <div styleName="cta-wrapper">
        <CallToActionSecondary
          label={i18next.t('cancel')}
          size="small"
          onClick={handleCancelComment}
        />
        <CallToActionPrimary
          label={i18next.t('post')}
          size="small"
          isDisabled={!isPostingEnabled}
          onClick={handleSubmitComment}
        />
      </div>
    </div>
  );
};

CallToActionWrapper.propTypes = {
  isPostingEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    .isRequired,
  isVisible: PropTypes.bool.isRequired,
  handleCancelComment: PropTypes.func.isRequired,
  handleSubmitComment: PropTypes.func.isRequired
};

export default CallToActionWrapper;
